import { isSafari } from 'react-device-detect'

import { APPLE_STORE_URL } from 'config/constants'
import { useOpenApp } from 'hooks'
import { Button } from 'ui'


const ButtonOpenApp = ({ children, ...btnProps }) => {
  const { openApp } = useOpenApp()

  if (isSafari) return (
    <Button isFull {...btnProps} to={{ pathname: APPLE_STORE_URL}} openNewTab>
      {children}
    </Button>
  )

  return (
    <Button isFull {...btnProps} onClick={openApp}>
      {children}
    </Button>
  )
}

export default ButtonOpenApp